import { render, staticRenderFns } from "./AaaSThirdPartLogin.vue?vue&type=template&id=ab25c146"
import script from "./AaaSThirdPartLogin.vue?vue&type=script&lang=js"
export * from "./AaaSThirdPartLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports